<template>
  <div id="def1" ref="main" class="container" />
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "HRadar",
  props: {
    picCharts: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chart: null, // 接收实例对象
    };
  },
  watch: {
    picCharts(newVal) {
      if (newVal !== "") {
        this.init();
      }
    },
  },
  mounted() {
    this.init();
  },

  methods: {
    init() {
      if (myChart != null && myChart !== "" && myChart !== undefined) {
        myChart.dispose(); // 销毁
      }
      var myChart = echarts.init(this.$refs.main);
      // 绘制图表
      var option = {
        color: ["#5189F8"],
        tooltip: {},
        radar: {
          axisName: {
            fontSize: 14,
            color: "#6D7278",
          },
          axisLine: {
            lineStyle: {
              color: "#ebeef3",
            },
          },
          shape: "circle",
          center: ["50%", "50%"],
          radius: "70%",
          triggerEvent: false,
          indicator: this.picCharts.indicator,
        },
        series: [
          {
            type: "radar",
            symbolSize: 1,
            areaStyle: {
              color: {
                type: "radial",
                x: 0.5,
                y: 0.5,
                r: 0.5,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(137, 190, 252, 0.05)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(81, 137, 248, 0.3)", // 100% 处的颜色
                  },
                ],
              },
            },
            lineStyle: {
              width: 2,
            },
            label: {
              normal: {
                show: true,
                formatter: (params) => {
                  return params.value;
                },
                color: "#3964E6",
              },
            },
            data: [
              {
                value: this.picCharts.radars,
                name: " ",
              },
            ],
          },
        ],
      };

      myChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 200px;
  // background: skyblue;
}
</style>
